import React from "react";
import { useDispatch } from "react-redux";
import { Navigate, Routes, Route } from "react-router-dom";
import _ from "lodash";

import { useMount } from "@sportal/cdk/hooks";
import { withLayout } from "../../components/layout/Layout";
import { BrandingForm } from "./tabs/brandingForm/BrandingForm";
import { WebFilteringForm } from "./tabs/webFilteringForm/WebFilteringForm";
import { MalwareForm } from "./tabs/malwareForm/MalwareForm";
import { loadResources } from "./resources.actions";
import { withPageName } from "../../components/layout/horizontalMenu/PageName";

import "./BlockPageContentPage.scss";

export const BlockPageContentPage = () => {
  const dispatch = useDispatch();

  useMount(() => {
    dispatch(loadResources());
  });

  return (
    <div className="blocked-page col-lg-10 col-md-12">
      <Routes>
        <Route path="branding" element={<BrandingForm />} />
        <Route path="webfilter" element={<WebFilteringForm />} />
        <Route path="malware" element={<MalwareForm />} />
        <Route path="*" element={<Navigate to="branding" />} />
      </Routes>
    </div>
  );
};

export default _.flowRight(withLayout(), withPageName())(BlockPageContentPage);
